// src/features/task/form/quickCreateBus.ts
// How the global create shortcut finds the task list's drawer.
//
// ⌘N is owned by the app shell and knows nothing about tasks; the drawer is
// owned by the task workspace and exists only while that page is open. Rather
// than teaching the shell to inspect the URL — which would be a guess about
// where a page lives — the workspace *registers* while it is mounted, and the
// shortcut asks whether anyone is listening. Nobody listening means the person
// is not on the task list, and the old behaviour (open the full page) stands.

type Listener = () => void;

const listeners = new Set<Listener>();

/** Register a drawer opener for as long as the task workspace is mounted. */
export function onTaskQuickCreateRequested(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/**
 * Ask the task list to open its quick-create drawer.
 * Returns false when there is no task list on screen, so the caller can fall
 * back to navigating to the full form.
 */
export function requestTaskQuickCreate(): boolean {
  if (listeners.size === 0) return false;
  for (const listener of [...listeners]) listener();
  return true;
}
